var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logLine.subject_type === 'reminders')?_c('div',{staticStyle:{"border-top":"1px solid #e1e0e0","padding":"10px 0"}},[_c('log-line-footer',{attrs:{"log-line":_vm.logLine}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }